module.exports = __webpack_public_path__ + "static/media/hryvnia.3f43f630.svg";